function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

function SvgManagedCluster(props) {
  const light = props.light || '#999';
  const dark = props.dark || '#000';
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 96 96",
    "uc-svg": "www"
  }, props), React.createElement("path", {
    d: "M72 56c-1.148 0-2.269.127-3.35.357L58.499 36.055C61.864 33.121 64 28.815 64 24c0-8.836-7.164-16-16-16s-16 7.164-16 16c0 4.815 2.137 9.12 5.501 12.055L27.35 56.357A16.087 16.087 0 0024 56c-8.836 0-16 7.164-16 16s7.164 16 16 16c7.088 0 13.091-4.615 15.192-11h17.616C58.909 83.385 64.912 88 72 88c8.836 0 16-7.164 16-16s-7.164-16-16-16zM48 16a8 8 0 110 16 8 8 0 010-16zM24 80a8 8 0 110-16 8 8 0 010 16zm32.302-11H39.697a15.998 15.998 0 00-5.198-9.055L44.65 39.643c1.081.23 2.202.357 3.35.357s2.269-.127 3.35-.357l10.151 20.303A15.985 15.985 0 0056.302 69zM72 80a8 8 0 110-16 8 8 0 010 16z"
  }));
}

SvgManagedCluster.clsName = 'icon-www__managed-cluster';
SvgManagedCluster.remarkName = 'unknown';
export default SvgManagedCluster;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@ucloud/ucloud-icons/dist/www/svgr/ManagedCluster.js
// module id = 2387
// module chunks = 17 18